import TailwindBottomButtonView from "../../../../components/mainBottomButtonView/TailwindBottomButtonView";
import { IngredientRegisterViewModel } from "../types/ingredientRegisterView.types";

interface IngredientRegisterFooterProps {
  vm: IngredientRegisterViewModel;
}

/**
 * Bottom action bar — the shared Tailwind `TailwindBottomButtonView`
 * (Cancel/Save), matching the pattern established by
 * `FilterVarientTableModal.tsx`. The "Ingredient Mapping" secondary action
 * (only relevant when `isIngredientMappingMode`) renders as its own small
 * row directly above this one in `IngredientRegisterModal.tsx`, since
 * `TailwindBottomButtonView` only supports a single primary save action.
 */
const IngredientRegisterFooter = ({ vm }: IngredientRegisterFooterProps) => {
  return (
    <TailwindBottomButtonView
      cancelButtonStatus
      saveButtonStatus
      saveTitle={vm.isIngredientMappingMode ? "Save" : vm.genericButtonTitle}
      buttonSize="lg"
      cancelButton={vm.onCancel}
      saveButton={vm.onSave}
      saveDisable={vm.disableCalculateButton}
    />
  );
};

export default IngredientRegisterFooter;
